<ces-formula-model-buttons
  (loadClick)="openLoadFormulaModelDialog()"
  (saveClick)="openSaveModelTemplateDialog()"
  containerClass="mb-(--space-2)" />
<form [formGroup]="form" class="p-(--space-3)" #formContainer tabindex="-1" (click)="markDatePickerAsTouchedAsync()">
  <div class="flex flex-col gap-(--gap-relaxed)">
    @if (this.entity && t.testMode()) {
      <div class="field">#ID : {{ this.entity.id }}</div>
    }
    @if (t.testMode()) {
      <ces-text-field
        boldLabel="medium"
        [label]="'common.labels.name' | transloco"
        [maxLength]="100"
        formControlName="name"
        [smallLabel]="true" />
    }

    <div class="flex flex-row gap-(--gap-loose)">
      <div class="field w-1/2">
        <!-- ces-datepicker is a composite widget (date + time inputs), not a labelable form
             element: a <label for> pointing at it is invalid HTML (axe: label misuse). The
             WAI-ARIA group-labelling pattern (span + role="group" + aria-labelledby) names
             the whole widget instead. Same rationale for the parameters and expression fields. -->
        <span id="startTs-label" class="cursor-default block text-sm font-medium mb-(--space-1)"
          >{{ 'forms.validityStart' | transloco }}<sup>*</sup></span
        >
        @if (t.testMode()) {
          <div class="text-xs">{{ form.get('startTs')?.value | date: 'dd.MM.yyyy HH:mm' }}</div>
        }
        <ces-datepicker
          id="startTs"
          formControlName="startTs"
          [autofocus]="false"
          role="group"
          aria-labelledby="startTs-label"
          class="w-full" />
        @if (isFieldInvalid('startTs')) {
          <small class="text-red-500 block mt-(--space-2)">
            {{ getErrorMessage('startTs') }}
          </small>
        }
      </div>
    </div>

    <ces-text-field
      [label]="'common.labels.comment' | transloco"
      type="textarea"
      formControlName="comment"
      [rows]="2"
      [smallLabel]="true"
      boldLabel="medium"
      [placeholder]="'forms.optionalComment' | transloco" />

    <div class="field">
      <span id="parameters-label" class="cursor-default block text-label mb-(--space-2)"
        >{{ 'forms.fields.parameters' | transloco }}<sup>*</sup></span
      >
      <ces-parameters-input
        formControlName="parameters"
        [units]="units"
        [measures]="measures"
        [mode]="ParameterMode.FORMULA"
        [allowedTypes]="allowedParameterTypes"
        role="group"
        aria-labelledby="parameters-label"
        (parametersChange)="onParametersChange($event)" />
      @if (isFieldInvalid('parameters')) {
        <small class="text-red-500">
          {{ getErrorMessage('parameters') }}
        </small>
      }
    </div>

    <div class="field">
      <div class="flex items-center justify-between mb-(--space-1)">
        <span id="expression-label" class="cursor-default block text-sm font-medium"
          >{{ 'forms.fields.expression' | transloco }}<sup>*</sup></span
        >
        <button
          type="button"
          class="ces-help-button"
          (click)="showFormulaHelp()"
          [pTooltip]="'forms.formulaHelp' | transloco"
          tooltipPosition="left"
          [attr.aria-label]="'forms.formulaHelp' | transloco">
          <i class="pi pi-question-circle" aria-hidden="true"></i>
        </button>
      </div>
      <div class="h-64">
        <ces-editor
          #expressionEditor
          id="expression"
          formControlName="expression"
          [variables]="editorVariables"
          [historicalFunctionsAvailable]="historicalFunctionsAvailable"
          [autoFormat]="true"
          [showLineNumbers]="true"
          role="group"
          aria-labelledby="expression-label"
          (expressionChange)="onExpressionChange($event)" />
      </div>
      @if (isFieldInvalid('expression')) {
        <small class="text-red-500">
          {{ getErrorMessage('expression') }}
        </small>
      }
    </div>

    @if (errorMessage) {
      <div class="text-red-500 mb-(--space-3)">
        {{ errorMessage }}
      </div>
    }

    <ces-dialog-footer [submitDisabled]="form.invalid || submitting" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
      @if (mode === 'edit' && entity) {
        <ces-delete-button
          footer-start
          [label]="'common.buttons.delete' | transloco"
          [disabled]="!canDeleteFormula()"
          [pTooltip]="deleteBlockedTooltip()"
          tooltipPosition="bottom"
          (confirm)="onDelete()"
          [confirmationConfig]="getDeleteConfirmationConfig()" />
      }
    </ces-dialog-footer>
  </div>
</form>

<ces-formula-help-modal
  [(visible)]="showHelpDialog"
  [parameters]="editorVariables"
  [historicalFunctionsAvailable]="historicalFunctionsAvailable"
  (functionInsert)="onFunctionInsert($event)" />
